<script setup lang="ts">
/**
 * Homepage - Metwide B2B Website
 *
 * Hero variants available:
 * - 'split': Split-screen layout (text left, image/graphic right)
 * - 'centered': Centered text with dark background
 *
 * Toggle the heroVariant ref below to switch between options.
 */

// Toggle this to switch between hero variants for comparison
const heroVariant = ref<"split" | "centered">("centered");

// SEO meta (canonical is handled globally in app.vue)
useSeoMeta({
  title: "Business Security, Connectivity & IT Solutions",
  description:
    "Metwide is one Australian partner for security, connectivity and managed IT. Trusted by 100+ businesses for reliable, accountable service. Talk to us.",
  ogTitle: "Business Security, Connectivity & IT Solutions",
  ogDescription:
    "Metwide is one Australian partner for security, connectivity and managed IT. Trusted by 100+ businesses for reliable, accountable service. Talk to us.",
  ogType: "website",
});
</script>

<template>
  <div>
    <!-- Hero Section - Toggle between variants -->
    <HomeHeroSplit v-if="heroVariant === 'split'" />
    <HomeHeroCentered v-else />

    <!-- Problem Hook - "Does this sound familiar?" -->
    <HomeProblemCards />

    <!-- Solution Pillars - Connectivity, Security, IT & Cloud -->
    <HomeSolutionPillars />

    <!-- Why Metwide - Trust points -->
    <HomeWhyMetwide />

    <!-- Social Proof - Stats, Projects, Logos -->
    <HomeSocialProof />

    <!-- Industries - Who we work with -->
    <HomeIndustries />

    <!-- Process - How it works -->
    <HomeProcess />

    <!-- Final CTA -->
    <HomeFinalCta />
  </div>
</template>
